module.exports = __webpack_public_path__ + "static/media/IMG_7087.ccb5ba49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/square/IMG_7087.jpg
// module id = 144
// module chunks = 0